import {
  SET_USER,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  LOADING_USER,
  EDIT_USER,
  CHANGE_IMAGE,
  STOP_LOADING_USER,
} from '../types'

const initialState = {
  authenticated: false,
  loading: false,
  credentials: {},
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
      }
    case SET_UNAUTHENTICATED:
      return initialState
    case SET_USER:
      return {
        ...state,
        authenticated: true,
        loading: false,
        credentials: action.payload,
      }
    case LOADING_USER:
      return {
        ...state,
        loading: true,
      }
    case STOP_LOADING_USER:
      return {
        ...state,
        loading: false,
      }

    case EDIT_USER:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          ...action.payload,
        },
      }

    case CHANGE_IMAGE:
      return {
        ...state,
        loading: false,
        credentials: {
          ...state.credentials,
          image: action.payload,
        },
      }

    default:
      return state
  }
}

export default userReducer
